import React from 'react';

interface MetricCardProps {
  icon: React.ElementType;
  label: string;
  value: number;
  unit: string;
  size?: "small" | "default" | "large";
  className?: string;
  hideLabel?: boolean;
  [key: string]: any;
}

const sizeClasses = {
  small: {
    card: "p-2",
    icon: "h-4 w-4",
    iconWrapper: "p-1",
    text: "text-sm",
    value: "text-base"
  },
  default: {
    card: "p-4",
    icon: "h-5 w-5",
    iconWrapper: "p-2",
    text: "text-base",
    value: "text-lg"
  },
  large: {
    card: "p-6",
    icon: "h-6 w-6",
    iconWrapper: "p-3",
    text: "text-lg",
    value: "text-xl"
  }
};

export function MetricCard({ 
  icon: Icon, 
  label, 
  value, 
  unit,
  size = "default",
  className = "",
  hideLabel = false,
  ...props
}: MetricCardProps) {
  const classes = sizeClasses[size];

  return (
    <div 
      className={`flex items-center justify-between ${classes.card} bg-muted/50 rounded-lg cursor-move transition-all duration-300 ${className}`}
      {...props}
    >
      <div className="flex items-center gap-3">
        <div className={`${classes.iconWrapper} bg-primary/10 rounded-full`}>
          <Icon className={`${classes.icon} text-primary`} />
        </div>
        {!hideLabel && <span className={`font-medium ${classes.text}`}>{label}</span>}
      </div>
      <span className={`${classes.value} font-semibold`}>
        {value.toLocaleString()} {unit}
      </span>
    </div>
  );
}